<template>
  <div class="dlrQuotationEntry">
    <div class="dlrQuotationEntry-bg" v-show="showType">
      <div class="dlrQuotationEntry-title">
        <p>{{ seriesName }}-真实报价单</p>
        <a
          href="javascript:void(0)"
          class="dlrQuotationEntry-close"
          v-stat:click="{
            action: !isICSApp
              ? 'dlr_baojia_page_close_click'
              : 'dlr_baojia_page_close3_click',
            extend: {
              channelId,
              seriesId: salesSeriesId,
              dealerId,
            },
          }"
          @click.stop="changeShowType(false)"
        ></a>
      </div>
      <div class="dlrQuotationEntry-box">
        <div class="dlrQuotationEntry-top">
          <p>
            <em>贷款落地预估</em><span>{{ loanLandingPrice }}万元</span>
          </p>
          <p>
            <em>全款落地预估</em><span>{{ fullLandingPrice }}万元</span>
          </p>
          <p><em>购车补贴</em><span>***元</span></p>
        </div>
        <div class="dlrQuotationEntry-cols">
          <div class="dlrQuotationEntry-col horz">
            <p>裸车价：***元</p>
            <p>商业险：***元</p>
          </div>
          <div class="dlrQuotationEntry-col horz">
            <p>购车补贴：***元</p>
            <p>必要花费：***元</p>
          </div>
          <div
            class="dlrQuotationEntry-col"
            v-stat:click="{
              action: !isICSApp
                ? 'dlr_baojia_page_rukou_click'
                : 'dlr_baojia_page_rukou_b_click',
              extend: {
                channelId,
                seriesId: salesSeriesId,
                dealerId,
              },
            }"
            v-stat:show="{
              action: !isICSApp
                ? 'dlr_baojia_page_rukou_show'
                : 'dlr_baojia_page_rukou_b_show',
              extend: {
                channelId,
                seriesId: salesSeriesId,
                dealerId,
              },
            }"
            @click="showDlrQuotationFn"
          >
            <div class="dlrQuotationEntry-btn">
              <a href="javascript:void(0);">
                <span>{{ isICSApp ? '打开报价单' : '获取限时报价' }}</span>
              </a>
            </div>
            <div class="dlrQuotationEntry-tips">
              <h6>{{ isICSApp ? '客户同步展示' : '共12项明细' }}</h6>
            </div>
          </div>
        </div>
      </div>
    </div>
    <p
      class="dlrQuotationEntry-small"
      v-show="!showType"
      @click="changeShowType(true)"
      v-stat:click="{
        action: !isICSApp
          ? 'dlr_baojia_page_expand_click'
          : 'dlr_baojia_page_expand3_click',
        extend: {
          channelId,
          seriesId: salesSeriesId,
          dealerId,
        },
      }"
    >
      <em></em>
      <span>真实报价单</span>
    </p>
  </div>
</template>
<script>
import { computed, defineComponent, ref } from 'vue-demi';
import store from '../../store/index';
import utils from '../../utils/util';
import priceListActionSync from '../../services/actionSync/priceList.action.proxy';
import eventBus from '@/services/eventBus.service';
export default defineComponent({
  name: 'DlrQuotationEntry',
  props: {
    isIcs: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const showType = ref(true);
    const priceListResult = computed(
      () => store.state.priceList.priceListResult,
    );
    const channelId = computed(() => store.state.sales.vrSalesInfo.channelId);
    const dealerId = computed(() => store.state.baseInfo.dealerId);
    const dealerSeriesList = computed(() => store.getters['dealer/seriesList']);
    const salesSeriesId = computed(() => store.state.dealer.salesSeriesId);
    const seriesName = computed(() => {
      let seriesInfo = dealerSeriesList.value.find(
        (o) => o.SeriesId === salesSeriesId.value,
      );
      if (seriesInfo) {
        return seriesInfo.SeriesName;
      }
      return '';
    });
    const isICSApp = utils.isICSApp();
    function showDlrQuotationFn() {
      priceListActionSync.showDlrQuotationFn();
    }
    function changeShowType(type) {
      priceListActionSync.changeShowType(type);
    }
    const loanLandingPrice = computed(() => {
      const price = utils.wanFilterWithUnit(
        priceListResult.value?.loan?.loanLandingPrice,
      );
      return utils.formatMoney(price.value);
    });
    const fullLandingPrice = computed(() => {
      const price = utils.wanFilterWithUnit(
        priceListResult.value.fullLandingPrice / 10000,
      );
      return utils.formatMoney(price.value);
    });
    
    eventBus.$on('changeShowType', (type) => {
      showType.value = type;
    });
    return {
      channelId,
      dealerId,
      isICSApp,
      priceListResult,
      salesSeriesId,
      seriesName,
      showType,
      loanLandingPrice,
      fullLandingPrice,
      showDlrQuotationFn,
      changeShowType,
    };
  },
});
</script>

<style lang="scss">
@import '@/assets/scss/modules/dlrQuotationEntry.scss';
</style>
